import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Link } from "react-router-dom";
import T from "i18n";

const Wrapper = styled.ul`
  @media print {
    display:block;    
  }
  display: flex;
  flex-wrap: wrap;

  li {
    display: flex;
    align-items: center;
      @media print {
      display:inline-block;    
      }
  }

  a {
    border: none;
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.palette.secondary};
    &:after {
      content: ">";
      display: inline-block;
      color: ${({ theme }) => theme.palette.accent};
      /* font-weight: bold; */
      padding: 0 0.5em;
    }
  }

  .leaf {
    color: ${({ theme }) => theme.palette.primary};
  }

  a,
  .leaf {
    padding: 0.5em 0;
  }

  p {
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-right:10px;
  }
`;

const Breadcrumbs = ({ className, steps }) => {
  const classes = ["Breadcrumbs"];
  if (className) classes.push(className);

  return (
    <Wrapper className={classes.join(" ")}>
      {(steps.length > 1 ? <p>{T({ path: "breadcrumbs.yourSelection" })}</p> : null)}
      {steps.map(
        (step, index) =>
          step.label && (
            <li key={step.label}>
              {index === steps.length - 1 ? (
                <span className="leaf">{step.label}</span>
              ) : (
                <Link to={step.path}>{step.label}</Link>
              )}
            </li>
          )
      )}
    </Wrapper>
  );
};

Breadcrumbs.displayName = "Breadcrumbs";

Breadcrumbs.propTypes = {
  className: PropTypes.string,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      path: PropTypes.string,
    })
  ),
};

Breadcrumbs.defaultProps = {
  className: null,
  steps: [],
};

export default Breadcrumbs;
